var exports = {
  "o": "DisablePin__rI40LW",
  "E": "ActionListOverrides__MrKKOf",
};

module.exports = exports;
